import { CurrencyType } from './enums/currency.enum';

export class AtlasRequest {
  bluefinIFrameId?: string;
  totalPrice: TotalPrice;
  orderId: string;
  airlineCode: string;
  documentNumber: string;
  airportCode: string;
  passengerName: string;

  constructor(
    bluefinIFrameId: string,
    amount: number,
    currencyString: string,
    orderId: string,
    airlineCode: string,
    documentNumber: string,
    airportCode: string,
    passengerName: string
  ) {
    this.bluefinIFrameId = bluefinIFrameId;
    this.orderId = orderId;
    this.airlineCode = airlineCode;
    this.documentNumber = documentNumber;
    this.airportCode = airportCode;
    this.passengerName = passengerName;

    const currencyType: CurrencyType = CurrencyType[currencyString as keyof typeof CurrencyType];
    this.totalPrice = { amount: amount, currency: currencyType };
  }
}

export interface TotalPrice {
  amount: number;
  currency: CurrencyType;
}
